import { render, staticRenderFns } from "./order_deliver_list.vue?vue&type=template&id=d8c5816a&scoped=true"
import script from "./order_deliver_list.vue?vue&type=script&lang=js"
export * from "./order_deliver_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c5816a",
  null
  
)

export default component.exports